export default "__VITE_ASSET__CzTZQuQo__"